module.exports = __webpack_public_path__ + "assets/4fa37d132ec3b8c4aaa2faca93d05692.svg";